<template>
  <div class="content">
    <div class="site-content container">
      <div class="sidebar" :class="bOpen ? 'opened': ''">
        <Sidebar />
      </div>
      <div class="header-content">
        <header class="header no-wrap wrap-xs">
          <MainResearch class="order-1 order-xs-3" :key="mainResearchKey" />
          <div @click="vOpenSidebar" class="btn-menu-responsive hide-md hide-lg">
            <i class="material-icons">menu</i>
          </div>
          <div @click="vHome()" class="logo-responsive hide-md hide-lg">
            <img src="@/common/assets/img/general/logo-satab-responsive.png" />
          </div>
          <TopAccount class="order-2 order-xs-1" />
          <TopCart class="order-3 order-xs-2" />
        </header>
        <div class="main-content">
          <slot></slot>
        </div>
      </div>
    </div>
    <div id="footer-container">
      <TopFooter />
      <Footer />
    </div>
  </div>
</template>

<script>
import TopFooter from "@/common/components/structure/TopFooter";
import Footer from "@/common/components/structure/Footer";
import Sidebar from "@/common/components/structure/Sidebar";
import TopCart from "@/modules/panier/components/TopCart";
import TopAccount from "@/modules/utilisateur/components/TopAccount";
import MainResearch from "@/modules/recherche/components/MainResearch";

import { Bus } from "@/common/Bus";

export default {
  components: {
    TopFooter,
    Footer,
    Sidebar,
    TopCart,
    TopAccount,
    MainResearch
  },
  data() {
    return {
      mainResearchKey: 1,
      bOpen: false,
      scrollY: null,
      top: null,
      topsidebar: null
    };
  },
  created() {
    Bus.$on("openSidebar", () => {
      this.bOpen = !this.bOpen;
      Bus.$emit("overlay", true);
      Bus.$emit("overlay");
    });

    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 200);
  },

  updated() {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 200);
  },
  mounted() {
    let element = document.querySelector(".header");
    this.top = element.offsetHeight;

    let sidebar = document.querySelector("#sidebar");
    this.topsidebar = sidebar.offsetHeight;

    let footer = document.querySelector("#footer-container");

    // window.addEventListener("scroll", () => {
    //   this.scrollY = Math.round(window.scrollY);

    //   if (this.scrollY <= footer.getBoundingClientRect().bottom - 1435) {
    //     sidebar.style.top = 0;
    //     sidebar.style.position = "fixed";
    //     sidebar.style.height = "auto";
    //     sidebar.style.maxWidth = "234px";
    //     sidebar.style.width = "100%";
    //   } else {
    //     sidebar.style.position = "absolute";
    //     sidebar.style.top = footer.offsetTop - sidebar.offsetHeight + "px";
    //   }

    //   if (this.scrollY >= this.top) {
    //     element.classList.add("sticky");
    //   } else {
    //     element.classList.remove("sticky");
    //   }
    // });
  },
  methods: {
    vOpenSidebar() {
      Bus.$emit("openSidebar");
    },
    vHome() {
      this.$router.push("/");
    }
  }
};
</script>

<style scoped>
.content {
  display: flex;
  width: 100%;
  flex-direction: column;
}

#sidebar {
  padding-bottom: 20px;
}

.main-content {
  position: relative;
  min-height: 1000px;
}

.sidebar {
  border: solid 1px #e9e9e9;
  width: 280px;
  z-index: 999;
  position: relative;
  z-index: 10000;
}

.site-content {
  width: 100%;
  display: flex;
  position: relative;
}

.header-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
}
.header {
  border-bottom: solid 1px #e9e9e9;
  display: flex;
  justify-content: flex-end;
  background-color: #fff;
}

.header.sticky {
  position: fixed;
  z-index: 10;
  width: 100%;
  max-width: 1278px;
}

.btn-menu-responsive {
  align-items: center;
  justify-content: center;
}

.btn-menu-responsive i {
  color: #fff;
  font-size: 2.5rem;
}

#opacity {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background-color: rgba(0, 0, 0, 0.9);
}

@media (max-width: 800px) {
  .sidebar {
    transform: translateX(-100%);
    position: fixed;
    transition: all 0.3s;
    height: 100vh;
  }
  .sidebar.opened {
    transform: translateX(0px);
    width: 100%;
  }
  .logo-responsive {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .logo-responsive img {
    width: 75%;
  }
  .btn-menu-responsive {
    background-color: red;
    min-width: 75px;
    height: 75px;
    display: flex;
  }
  .main-content {
    margin-top: 70px;
  }
}

@media (max-width: 1024px) {
  .main-content {
    margin-top: 90px;
  }
}

@media (max-width: 1370px) {
  .sidebar {
    transform: translateX(-100%);
    position: fixed;
    transition: all 0.3s;
    height: 100vh;
  }
  .sidebar.opened {
    transform: translateX(0px);
  }
  .logo-responsive {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .logo-responsive img {
    width: 75%;
    height: auto;
  }
  .btn-menu-responsive {
    background-color: red;
    min-width: 75px;
    height: 75px;
    display: flex;
  }
  .header.sticky {
    max-width: 100%;
  }
  .header {
    height: 76px;
  }
  .main-content {
    margin-top: 90px;
  }
}
</style>